import React from "react";
export var MenuContext = React.createContext(null);